import { parseStringifiedJson } from "@/lib/jsonParse";
import ReactJsonView from "@microlink/react-json-view";
import { memo } from "react";
import type { CumulativeDebugInfo } from "@/types/classification";

const DebugInfoJsonViewer = ({ debugInfo }: { debugInfo: string | object | null | undefined }) => {
  const parsedDebugInfo = parseStringifiedJson(debugInfo) as object;

  // Check if this is CumulativeDebugInfo and extract errors
  const isCumulativeDebugInfo =
    Array.isArray(parsedDebugInfo) &&
    parsedDebugInfo.length > 0 &&
    typeof parsedDebugInfo[0] === "object" &&
    "stepName" in parsedDebugInfo[0];

  const errors = isCumulativeDebugInfo
    ? (parsedDebugInfo as CumulativeDebugInfo)
        .filter((item) => item.error)
        .map((item) => ({ stepName: item.stepName, error: item.error }))
    : [];

  return (
    <div className="space-y-4">
      {/* Display errors at the top if present */}
      {errors.length > 0 && (
        <div className="rounded-md border-2 border-red-500 bg-red-50 p-4">
          <h4 className="font-medium text-red-800 mb-2">Errors in Debug Steps:</h4>
          <div className="space-y-2">
            {errors.map((errorItem, index) => (
              <div key={index} className="text-sm">
                <span className="font-medium text-red-700">{errorItem.stepName}:</span>
                <pre className="text-red-600 mt-1 whitespace-pre-wrap break-words">{errorItem.error}</pre>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Display the full debug info */}
      <ReactJsonView
        src={parsedDebugInfo}
        name={false}
        indentWidth={2}
        collapsed={2}
        enableClipboard={true}
        displayDataTypes={false}
        style={{ fontSize: "14px" }}
      />
    </div>
  );
};

export default memo(DebugInfoJsonViewer);
